import ErrorUtils from 'utils/error-utils';
/**
 * Redirect to an url via window.location.href
 * Encapsulating logic in this method allows easy mocking in unit tests.
 * @param {string} url to be redirected
 */
export function redirect(url) {
    window.location.href = url;
}
/**
 * Redirect to a url via window.location.replace, which does not leave the
 * current page in browser history (back button skips it).
 * @param {string} url to be redirected
 */
export function replaceUrl(url) {
    try {
        window.location.replace(url);
    }
    catch (error) {
        ErrorUtils.sendSentryMessage({ error, additionalData: { url } });
    }
}
